import { Component, OnInit, Input, OnDestroy, AfterViewInit, NgZone } from "@angular/core";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { ReportKind } from "projects/sepidz-web-framework/src/lib/models/enums";
import { ShowToastrService, HttpCommonService, AuthService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { SaveReportFile } from "projects/sepidz-web-framework/src/lib/models";
import { TranslateService } from "@ngx-translate/core";
import { PersianDatePipe } from "projects/sepidz-web-framework/src/lib/pipes/persian-date.pipe";
import { PersianNumberPipe } from "projects/sepidz-web-framework/src/lib/pipes/persian-number.pipe";
import { ThousandSeparatorPipe } from "projects/sepidz-web-framework/src/lib/pipes/thousand-separator.pipe";
declare var Stimulsoft: any;
import * as moment from "jalali-moment";

export class Printer {
  id: number;
  name: string;
  active: boolean;
  blacklisted: boolean;
  default: boolean;
}
export class ReportInfo {
  apiName: string;
  reportKind: ReportKind;
  reportName: string;
  oldReportName: string;
  reportTitle: string;
  pathPreFix: string;
  dataList: any[];
  saveReportFile: SaveReportFile;
  startDate?: Date;
  endDate?: Date;
  startNumber?: number;
  endNumber?: number;
  filterText?: string;
  includeTime: boolean = false;
  reportVariables: any;
  DataSourceName?: string = null;
}
@Component({
  selector: "ngx-stimul-soft-report",
  templateUrl: "./stimul-soft-report.component.html",
  styleUrls: ["./stimul-soft-report.component.scss"],
  providers: [PersianDatePipe, PersianNumberPipe, ThousandSeparatorPipe],
})
export class StimulSoftReportComponent implements OnInit, OnDestroy, AfterViewInit {
  options: any;
  designer: any;
  viewer: any;
  report: any;
  @Input() saveReportFile: SaveReportFile;
  @Input() reportKind: ReportKind = ReportKind.newReport;
  @Input() apiName: string;
  @Input() pathPreFix: string;
  @Input() reportTitle: string;
  @Input() reportVariables: any;
  _dataList: any[];
  @Input()
  get dataList(): any[] {
    return this._dataList;
  }
  set dataList(value: any[]) {
    this._dataList = value;
  }
  translate(str: string): string {
    return this.translateText.instant(str);
  }

  constructor(
    private id: FormContainerModel,
    private sts: ShowToastrService,
    private hcs: HttpCommonService,
    private reportInfo: ReportInfo,
    private zone: NgZone,
    private authService: AuthService,
    private translateText: TranslateService,
    private persianDatePipe: PersianDatePipe,
    private persianNumberPipe: PersianNumberPipe,
    private tabsservice: TabularService
  ) {
    this.apiName = reportInfo.apiName;
    this.reportKind = reportInfo.reportKind;
    this.dataList = reportInfo.dataList;
    this.reportTitle = reportInfo.reportTitle;
    this.pathPreFix = reportInfo.pathPreFix;
    this.saveReportFile = reportInfo.saveReportFile;
    this.reportVariables = reportInfo.reportVariables;
    this.MiladiToShamsi = this.MiladiToShamsi.bind(this);
    this.MiladiToShamsi8 = this.MiladiToShamsi8.bind(this);
    this.MiladiToShamsiDayOfMonth = this.MiladiToShamsiDayOfMonth.bind(this);
    this.MiladiToShamsiMonth = this.MiladiToShamsiMonth.bind(this);
    this.MiladiToShamsiYear = this.MiladiToShamsiYear.bind(this);
    this.SetTimeToText = this.SetTimeToText.bind(this);
    this.FarsiMonthName = this.FarsiMonthName.bind(this);
    this.ReapeatChar = this.ReapeatChar.bind(this);
    this.PersianNumberThousandSeparator = this.PersianNumberThousandSeparator.bind(this);
  }

  ngOnInit(): void {
    let currentBranch = this.authService.currentBranch;
    this.loadDesigner();
    //setTimeout(() => this.zone.run(() => { this.loadDesigner(); }), 500);
  }
  ngOnDestroy(): void {
    this.options = undefined;
    this.designer = undefined;
    this.viewer = undefined;
    this.report = undefined;
  }
  ngAfterViewInit(): void {}
  getDataSourceName() {
    if (this.reportInfo.DataSourceName) return this.reportInfo.DataSourceName;
    if (this.pathPreFix === "FrontOffice" && this.apiName.split("/")[0] === "Invoice") return "InvoicePrintModel";
    return this.apiName.split("/")[0];
  }
  SetCaptions(report: any) {
    let index: number = 0;
    let preFix = "";
    if (this.pathPreFix === "SALE") preFix = "FrontOffice";
    if (
      this.pathPreFix === "INV" ||
      this.pathPreFix === "ACC" ||
      this.pathPreFix === "TRS" ||
      this.pathPreFix === "HRM" ||
      this.pathPreFix === "SELL"
    )
      preFix = "BackOffice";
    if (report.dictionary && report.dictionary.relations && report.dictionary.relations.list) {
      report.dictionary.relations.list.forEach((x) => {
        x.alias = this.saveReportFile.ReportTitle;
        x.name = x.name.replace("root", this.getDataSourceName());
        x.nameInSource = x.nameInSource.replace("root", this.getDataSourceName());
      });
    }
    report.reportAlias = this.saveReportFile.ReportTitle;
    if (report.dictionary.dataStore) {
      report.dictionary.dataStore.list.forEach((x) => {
        if (x.name.includes("root")) {
          x.name = x.name.replace("root", this.getDataSourceName());
          x.data.tableName = x.data.tableName.replace("root", this.getDataSourceName());
        }
      });
    }
    if (report && report.dictionary && report.dictionary.dataSources) {
      if (report.dictionary.dataSources.list) {
        report.dictionary.dataSources.list.forEach((x) => {
          if (x.name.includes("root")) {
            x.name = x.name.replace("root", this.getDataSourceName());
            x.nameInSource = x.nameInSource.replace("root", this.getDataSourceName());
            x.alias = this.saveReportFile.ReportTitle + (x.alias.includes("Items") ? "-" + this.translate("ClientApp.StimulSoft.Items") : "");
          }
          if (x.dataTable && x.dataTable.childRelations && x.dataTable.childRelations.list && x.dataTable.childRelations.list.length > 0) {
            x.dataTable.childRelations.list.forEach((r) => {
              r.relationName = r.relationName.replace("root", this.getDataSourceName());
            });
          }
          x.columns.list.forEach((c) => {
            index++;
            let entityName: string = x.name;
            if (
              entityName.includes("_") &&
              (entityName.substring(entityName.length - 1) === "s" || entityName.substring(entityName.length - 6) === "s_Item")
            ) {
              if (entityName.substring(entityName.length - 6) === "s_Item") entityName = entityName.substring(0, entityName.length - 6);
              else entityName = entityName.substring(0, entityName.length - 1);
              entityName = entityName.replace("_", "");
            }
            if (preFix) c.alias = this.translate(`ClientApp.${preFix}.${this.pathPreFix}.${entityName}.${c.name}`);
            else c.alias = this.translate(`ClientApp.${this.pathPreFix}.${entityName}.${c.name}`);
          });
        });
      }
    }
  }
  setVariable() {
    if (!this.report.dictionary.variables.getByName("CompanyName")) {
      var newVariable = new Stimulsoft.Report.Dictionary.StiVariable();
      newVariable.name = "CompanyName";
      newVariable.alias = this.translate("ClientApp.StimulSoft.CompanyName");
      newVariable.valueObject = this.authService.currentBranch.CompanyTitle;
      this.report.dictionary.variables.add(newVariable);
    } else this.report.dictionary.variables.getByName("CompanyName").valueObject = this.authService.currentBranch.CompanyTitle;
    if (!this.report.dictionary.variables.getByName("BranchTitle")) {
      var newVariable = new Stimulsoft.Report.Dictionary.StiVariable();
      newVariable.name = "BranchTitle";
      newVariable.alias = this.translate("ClientApp.StimulSoft.BranchName");
      newVariable.valueObject = this.authService.currentBranch.Title;
      this.report.dictionary.variables.add(newVariable);
    } else this.report.dictionary.variables.getByName("BranchTitle").valueObject = this.authService.currentBranch.Title;

    if (!this.report.dictionary.variables.getByName("BranchId")) {
      var newVariable = new Stimulsoft.Report.Dictionary.StiVariable();
      newVariable.name = "BranchId";
      newVariable.alias = this.translate("ClientApp.StimulSoft.BranchSeries");
      newVariable.valueObject = this.authService.currentBranchId;
      this.report.dictionary.variables.add(newVariable);
    } else this.report.dictionary.variables.getByName("BranchId").valueObject = this.authService.currentBranchId;

    let date = this.persianDatePipe.transform(new Date());
    if (!this.report.dictionary.variables.getByName("ShamsiDate")) {
      var newVariable = new Stimulsoft.Report.Dictionary.StiVariable();
      newVariable.name = "ShamsiDate";
      newVariable.alias = this.translate("ClientApp.StimulSoft.ReportDate");

      newVariable.valueObject = this.persianNumberPipe.transform(date);
      this.report.dictionary.variables.add(newVariable);
    } else this.report.dictionary.variables.getByName("ShamsiDate").valueObject = this.persianNumberPipe.transform(date);
    if (!this.report.dictionary.variables.getByName("StartDate")) {
      var newVariable = new Stimulsoft.Report.Dictionary.StiVariable();
      newVariable.name = "StartDate";
      newVariable.alias = this.translate("ClientApp.StimulSoft.StartDate");
      if (this.reportInfo.startDate) newVariable.valueObject = moment(this.reportInfo.startDate).locale("fa").format("YYYY/MM/DD");
      this.report.dictionary.variables.add(newVariable);
    } else this.report.dictionary.variables.getByName("StartDate").valueObject = moment(this.reportInfo.startDate).locale("fa").format("YYYY/MM/DD");
    if (!this.report.dictionary.variables.getByName("EndDate")) {
      var newVariable = new Stimulsoft.Report.Dictionary.StiVariable();
      newVariable.name = "EndDate";
      newVariable.alias = this.translate("ClientApp.StimulSoft.EndDate");
      if (this.reportInfo.endDate) newVariable.valueObject = moment(this.reportInfo.endDate).locale("fa").format("YYYY/MM/DD");
      this.report.dictionary.variables.add(newVariable);
    } else this.report.dictionary.variables.getByName("EndDate").valueObject = moment(this.reportInfo.endDate).locale("fa").format("YYYY/MM/DD");

    if (!this.report.dictionary.variables.getByName("StartDateTime")) {
      var newVariable = new Stimulsoft.Report.Dictionary.StiVariable();
      newVariable.name = "StartDateTime";
      newVariable.alias = this.translate("ClientApp.StimulSoft.StartTime");
      if (this.reportInfo.startDate) newVariable.valueObject = moment(this.reportInfo.startDate).locale("fa").format("HH:mm");
      this.report.dictionary.variables.add(newVariable);
    } else {
      this.report.dictionary.variables.getByName("StartDateTime").valueObject = moment(this.reportInfo.startDate).locale("fa").format("HH:mm");
    }

    if (!this.report.dictionary.variables.getByName("EndDateTime")) {
      var newVariable = new Stimulsoft.Report.Dictionary.StiVariable();
      newVariable.name = "EndDateTime";
      newVariable.alias = this.translate("ClientApp.StimulSoft.EndTime");
      if (this.reportInfo.endDate) newVariable.valueObject = moment(this.reportInfo.endDate).locale("fa").format("HH:mm");
      this.report.dictionary.variables.add(newVariable);
    } else {
      this.report.dictionary.variables.getByName("EndDateTime").valueObject = moment(this.reportInfo.endDate).locale("fa").format("HH:mm");
    }

    if (!this.report.dictionary.variables.getByName("StartNumber")) {
      var newVariable = new Stimulsoft.Report.Dictionary.StiVariable();
      newVariable.name = "StartNumber";
      newVariable.alias = this.translate("ClientApp.StimulSoft.StartNumber");
      if (this.reportInfo.startNumber) newVariable.valueObject = this.reportInfo.startNumber.toString();
      this.report.dictionary.variables.add(newVariable);
    } else
      this.report.dictionary.variables.getByName("StartNumber").valueObject = this.reportInfo.startNumber
        ? this.reportInfo.startNumber.toString()
        : "";

    if (!this.report.dictionary.variables.getByName("EndNumber")) {
      var newVariable = new Stimulsoft.Report.Dictionary.StiVariable();
      newVariable.name = "EndNumber";
      newVariable.alias = this.translate("ClientApp.StimulSoft.EndNumber");
      if (this.reportInfo.endNumber) newVariable.valueObject = this.reportInfo.endNumber.toString();
      this.report.dictionary.variables.add(newVariable);
    } else
      this.report.dictionary.variables.getByName("EndNumber").valueObject = this.reportInfo.endNumber ? this.reportInfo.endNumber.toString() : "";
    if (!this.report.dictionary.variables.getByName("FilterText")) {
      var newVariable = new Stimulsoft.Report.Dictionary.StiVariable();
      newVariable.name = "FilterText";
      newVariable.alias = this.translate("ClientApp.StimulSoft.FilterText");

      newVariable.valueObject = this.reportInfo.filterText;
      this.report.dictionary.variables.add(newVariable);
    } else this.report.dictionary.variables.getByName("FilterText").valueObject = this.reportInfo.filterText;
    if (!this.report.dictionary.variables.getByName("IncludeTime")) {
      var newVariable = new Stimulsoft.Report.Dictionary.StiVariable();
      newVariable.name = "IncludeTime";
      newVariable.alias = this.translate("ClientApp.StimulSoft.IncludeTime");

      newVariable.valueObject = this.reportInfo.includeTime;
      this.report.dictionary.variables.add(newVariable);
    } else this.report.dictionary.variables.getByName("IncludeTime").valueObject = this.reportInfo.includeTime;

    if (this.reportVariables) {
      Object.keys(this.reportVariables).forEach((key) => {
        if (!this.report.dictionary.variables.getByName(key)) {
          var newVariable = new Stimulsoft.Report.Dictionary.StiVariable();
          newVariable.name = key;

          newVariable.valueObject = this.reportVariables[key];
          this.report.dictionary.variables.add(newVariable);
        } else this.report.dictionary.variables.getByName(key).valueObject = this.reportVariables[key];
      });
    }
  }
  loadDesigner() {
    this.setFunction();
    if (this.reportKind === ReportKind.newReport || this.reportKind === ReportKind.editReport) {
      this.setReportDesigner();
      this.report = new Stimulsoft.Report.StiReport();
      this.report.dictionary.dataStore.clear();
      if (this.saveReportFile.FileName && this.reportKind === ReportKind.editReport)
        this.report.loadFile(
          `assets/reports/${this.saveReportFile.SystemKindName.split("_")[0]}/${this.fnGetRepoPath(
            !this.reportInfo.oldReportName ? this.saveReportFile.FileName : this.reportInfo.oldReportName
          )}`
        );
      if (!this.report.reportFile) this.report.reportFile = this.saveReportFile.FileName;
      else if (this.reportInfo.oldReportName) this.report.reportFile = this.saveReportFile.FileName;
      this.setVariable();
      this.report.dictionary.dataSources.clear();
      this.report.dictionary.databases.clear();
      this.report.dictionary.relations.clear();

      this.report.regData(this.getDataSourceName(), this.saveReportFile.ReportTitle, this.dataList);
      this.report.dictionary.synchronize();
      this.SetCaptions(this.report);
      this.designer.report = this.report;
      setTimeout(() => this.designer.renderHtml("content"), 100);
    } else if (this.reportKind === ReportKind.preview) {
      this.report = new Stimulsoft.Report.StiReport();
      this.report.dictionary.dataStore.clear();
      if (this.saveReportFile.FileName)
        this.report.loadFile(
          `assets/reports/${this.saveReportFile.SystemKindName.split("_")[0]}/${this.fnGetRepoPath(this.saveReportFile.FileName)}`
        );
      if (!this.report.reportFile) {
        this.sts.showDialog(this.translate("ClientApp.StimulSoft.PrintTemplateNotFound"), this.translate("ClientApp.StimulSoft.ErrorMessage"));
        this.tabsservice.closeById(this.id.metadata.id);
      } else {
        this.setVariable();
        this.report.dictionary.dataSources.clear();
        this.report.dictionary.databases.clear();
        this.report.dictionary.relations.clear();
        this.report.regData(this.getDataSourceName(), this.saveReportFile.ReportTitle, this.dataList);
        this.report.dictionary.synchronize();
        this.SetCaptions(this.report);
        this.viewer = new Stimulsoft.Viewer.StiViewer(this.options, "StiViewer", false);
        this.viewer.report = this.report;
        setTimeout(() => this.viewer.renderHtml("content"), 100);
      }
    } else if (this.reportKind === ReportKind.print) {
      setTimeout(() => this.printRepot(), 200);
    } else if (this.reportKind === ReportKind.saveReport) {
      this.report = new Stimulsoft.Report.StiReport();
      this.report.dictionary.dataStore.clear();
      if (this.saveReportFile.FileName)
        this.report.loadFile(
          `assets/reports/${this.saveReportFile.SystemKindName.split("_")[0]}/${this.fnGetRepoPath(this.saveReportFile.FileName)}`
        );
      if (this.report.reportFile) {
        this.SaveReport(this.report);
      }
    }
  }
  public printRepot(): void {
    const rep = new Stimulsoft.Report.StiReport();
    this.report = rep;
    this.report.dictionary.dataStore.clear();
    this.report.loadFile(`assets/reports/${this.saveReportFile.SystemKindName.split("_")[0]}/${this.fnGetRepoPath(this.saveReportFile.FileName)}`);
    if (!this.report.reportFile)
      this.sts.showDialog(this.translate("ClientApp.StimulSoft.PrintTemplateNotFound"), this.translate("ClientApp.StimulSoft.ErrorMessage"));
    else {
      this.setVariable();
      this.report.dictionary.dataSources.clear();
      this.report.dictionary.databases.clear();
      this.report.dictionary.relations.clear();
      this.report.regData(this.getDataSourceName(), this.saveReportFile.ReportTitle, this.dataList);
      this.report.dictionary.synchronize();
      this.SetCaptions(this.report);
      this.report.renderAsync(() => rep.print(false));
    }
    setTimeout(() => this.tabsservice.closeById(this.id.metadata.id), 500);
  }
  public PersianNumberThousandSeparator = function (value: number) {
    return this.persianNumberPipe.transform(this.thousandSeparatorPipe.transform(value));
  };
  public MiladiToShamsi = function (value: Date) {
    return this.persianDatePipe.transform(value);
  };
  public MiladiToShamsi8 = function (value: Date) {
    return moment(value.toString()).format("jYYYYjMMjDD");
  };
  public MiladiToShamsiDayOfMonth = function (value: Date) {
    const date = moment(value) || moment();
    return date.jDate();
  };
  public MiladiToShamsiMonth = function (value: Date) {
    const date = moment(value) || moment();
    return date.jMonth() + 1;
  };
  public MiladiToShamsiYear = function (value: Date) {
    const date = moment(value) || moment();
    return date.jYear();
  };
  public MiladiToAlphaShamsi = function (value: Date) {
    const date = moment(value) || moment();
    return date.jYear();
  };
  public FarsiMonthName = function (month: number) {
    let MonthsName = [
      this.translate("ClientApp.StimulSoft.April"),
      this.translate("ClientApp.StimulSoft.May"),
      this.translate("ClientApp.StimulSoft.June"),
      this.translate("ClientApp.StimulSoft.July"),
      this.translate("ClientApp.StimulSoft.August"),
      this.translate("ClientApp.StimulSoft.September"),
      this.translate("ClientApp.StimulSoft.October"),
      this.translate("ClientApp.StimulSoft.November"),
      this.translate("ClientApp.StimulSoft.December"),
      this.translate("ClientApp.StimulSoft.January"),
      this.translate("ClientApp.StimulSoft.February"),
      this.translate("ClientApp.StimulSoft.March"),
    ];
    return MonthsName[month - 1];
  };
  public ReapeatChar = function (character: string, count: number) {
    if (count <= 0) return "";
    return character.repeat(count);
  };
  public SetTimeToText = function (value: number, kind: number, dayBase: number = 0): string {
    if (kind <= 0 || kind > 3) {
      return value.toString();
    }
    if (kind > 0) kind--;
    if (!dayBase) dayBase = 440;
    let T: string = "";
    //if (V <= 0)
    //    return T;
    let RC = "";
    let DD = 0;
    let Day = value % dayBase;
    let HH = 0;
    let MM = 0;
    switch (kind) {
      case 0:
        DD = Math.round(value / (dayBase * 1.0));
        T = DD.toString();
        break;
      case 1:
        DD = Math.round(value / dayBase);
        MM = Day % 60;
        HH = (Day - MM) / 60;
        RC = "";
        for (var i = 0; i < 3 - DD.toString().length; i++) RC += "0";
        T = RC + DD.toString();
        if (HH < 10) T += ":0" + HH.toString();
        else T += ":" + MM.toString();
        if (MM < 10) T += ":0" + MM.toString();
        else T += ":" + MM.toString();
        break;
      case 2:
        MM = value % 60;
        HH = (value - MM) / 60;

        RC = "";
        for (var i = 0; i < 3 - HH.toString().length; i++) RC += "0";
        T = RC + HH.toString();
        if (MM < 10) T += ":0" + MM.toString();
        else T += ":" + MM.toString();
        break;
    }
    if (value < 0) T = "(" + T.replace("-", "") + ")";
    return T;
  };
  setFunction() {
    Stimulsoft.Report.Dictionary.StiFunctions.addFunction(
      "UserFunction",
      "SetTimeToText",
      "SetTimeToText",
      this.translate("ClientApp.StimulSoft.ConvertTimeToString"),
      "",
      String,
      "",
      [Number, Number, Number],
      ["value, kind,dayBase"],
      ["مقدار,نوع تبدیل,مبنای روز"],
      this.SetTimeToText
    );
    Stimulsoft.Report.Dictionary.StiFunctions.addFunction(
      "UserFunction",
      "SetTimeToText",
      "SetTimeToText",
      this.translate("ClientApp.StimulSoft.ConvertTimeToString"),
      "",
      String,
      "",
      [Number, Number],
      ["value, kind"],
      ["نوع تبدیل,مبنای روز"],
      this.SetTimeToText
    );
    Stimulsoft.Report.Dictionary.StiFunctions.addFunction(
      "UserFunction",
      "MiladiToShamsi",
      "MiladiToShamsi",
      this.translate("ClientApp.StimulSoft.ConvertingGregorianDateSolar"),
      "",
      String,
      "",
      [Date],
      ["Date"],
      ["تاریخ"],
      this.MiladiToShamsi
    );
    Stimulsoft.Report.Dictionary.StiFunctions.addFunction(
      "UserFunction",
      "MiladiToShamsi8",
      "MiladiToShamsi8",
      this.translate("ClientApp.StimulSoft.ConvertingGregorianDateSolar"),
      "",
      String,
      "",
      [Date],
      ["Date"],
      ["تاریخ"],
      this.MiladiToShamsi8
    );
    Stimulsoft.Report.Dictionary.StiFunctions.addFunction(
      "UserFunction",
      "MiladiToShamsiDayOfMonth",
      "MiladiToShamsiDayOfMonth",
      this.translate("ClientApp.StimulSoft.NumberDaysSolarMonth"),
      "",
      Number,
      "",
      [Date],
      ["Date"],
      ["تاریخ"],
      this.MiladiToShamsiDayOfMonth
    );
    Stimulsoft.Report.Dictionary.StiFunctions.addFunction(
      "UserFunction",
      "MiladiToShamsiMonth",
      "MiladiToShamsiMonth",
      this.translate("ClientApp.StimulSoft.SolarMonth"),
      "",
      Number,
      "",
      [Date],
      ["Date"],
      ["تاریخ"],
      this.MiladiToShamsiMonth
    );
    Stimulsoft.Report.Dictionary.StiFunctions.addFunction(
      "UserFunction",
      "MiladiToShamsiYear",
      "MiladiToShamsiYear",
      this.translate("ClientApp.StimulSoft.SolarYear"),
      "",
      Number,
      "",
      [Date],
      ["Date"],
      ["تاریخ"],
      this.MiladiToShamsiYear
    );
    Stimulsoft.Report.Dictionary.StiFunctions.addFunction(
      "UserFunction",
      "FarsiMonthName",
      "FarsiMonthName",
      this.translate("ClientApp.StimulSoft.MonthOfFarsi"),
      "",
      String,
      "",
      [Number],
      ["Month"],
      ["ماه"],
      this.FarsiMonthName
    );
    Stimulsoft.Report.Dictionary.StiFunctions.addFunction(
      "UserFunction",
      "ReapeatChar",
      "ReapeatChar",
      this.translate("ClientApp.StimulSoft.WordRepetition"),
      "",
      String,
      "",
      [String, Number],
      ["Char,Count"],
      ["کلمه,تعداد"],
      this.ReapeatChar
    );
    Stimulsoft.Report.Dictionary.StiFunctions.addFunction(
      "UserFunction",
      "PersianNumberThousandSeparator",
      "PersianNumberThousandSeparator",
      this.translate("ClientApp.StimulSoft.ThreeDigitSeparatorPersian"),
      "",
      String,
      "",
      [Number],
      ["Value"],
      ["مقدار"],
      this.PersianNumberThousandSeparator
    );
  }
  setReportDesigner() {
    this.options = new Stimulsoft.Designer.StiDesignerOptions();
    this.options.appearance.fullScreenMode = false;
    this.options.toolbar.showFileMenuExit = true;
    this.options.appearance.showLocalization = true;
    this.options.toolbar.showAboutButton = true;
    this.options.toolbar.printDestination = Stimulsoft.Viewer.StiPrintDestination.Default;
    this.options.toolbar.showPrintButton = false;
    this.options.appearance.htmlRenderMode = Stimulsoft.Report.Export.StiHtmlExportMode.Table;
    Stimulsoft.Base.Localization.StiLocalization.localizationPath = "../../assets/reports/locales";
    Stimulsoft.Base.Localization.StiLocalization.addLocalizationFile("../../assets/reports/locales/fa.xml", true, "Farsi");
    try {
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/iransans/woff/IRANSansX-Regular.woff", "IRAN Sans");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/BNAZANB.TTF", "B Nazanin");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/BNazanin.ttf", "B_Nazanin");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/TITR.TTF", "TITR");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/TITRB_SF.TTF", "TITR B");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/tahoma.ttf", "Tahoma_");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/tahomabd.ttf", "Tahoma bd");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/times.ttf", "times");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/timesbd.ttf", "timesbd");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/timesbi.ttf", "timesbi");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/timesi.ttf", "timesi");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/TRAF__SF.TTF", "TRAF__SF");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/trafb_sf.ttf", "trafb");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/BMitraBold_0.ttf", "BMitraBold_0");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/BMitra_0.ttf", "BMitra_0");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/BTitrBold_0.ttf", "BTitrBold_0");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/BROYA.TTF", "BROYA");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/BROYABD.TTF", "BROYABD");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/BTrafcBd_0.ttf", "BTrafcBd_0");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/BTraffic_2.ttf", "BTraffic_2");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/BYekan_0.ttf", "BYekan_0");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/framd_0.ttf", "framd_0");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/framdit_0.ttf", "framdit_0");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/frank.ttf", "frank");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/FRE3OF9X.TTF", "FRE3OF9X");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/FREE3OF9.TTF", "FREE3OF9");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/IranNastaliq_4.ttf", "IranNastaliq_4");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/IRANSans.ttf", "IRANSans");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/IRANSans_Bold.ttf", "IRANSans_Bold");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/IRANSans_Light.ttf", "IRANSans_Light");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/IRANSans_Medium.ttf", "IRANSans_Medium");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/IRANSans_UltraLight.ttf", "IRANSans_UltraLight");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/TRAF__SF.TTF", "TRAF__SF");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/trafb_sf.ttf", "trafb_sf");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/WINGDNG2.TTF", "WINGDNG2");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/YekanBakhFaNum-Regular.TTF", "YekanBakhFaNum-Regular");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/YekanBakhFaNum-Black.TTF", "YekanBakhFaNum-Black");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/YekanBakhFaNum-Bold.TTF", "YekanBakhFaNum-Bold");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/YekanBakh-Regular.TTF", "YekanBakh-Regular");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/YekanBakh-Black.TTF", "BYekanBakh-Black");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/YekanBakh-Bold.TTF", "YekanBakh-Bold");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/YekanBakhNoEn-Regular.TTF", "YekanBakhNoEn-Regular");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/YekanBakhNoEn-Black.TTF", "YekanBakhNoEn-Black");
      } catch (e) {
        console.log(e);
      }
      try {
        Stimulsoft.Base.StiFontCollection.addOpentypeFontFile("../../assets/fonts/YekanBakhNoEn-Bold.TTF", "YekanBakhNoEn-Bold");
      } catch (e) {
        console.log(e);
      }
    } catch (e) {
      console.log(e);
    }
    this.designer = new Stimulsoft.Designer.StiDesigner(this.options, "StiDesigner", false);
    this.designer.onSaveReport = this.SaveReport;
    this.designer.onCreateReport = this.CreateReport;
  }

  public LoadReport = (e) => {
    e.report.regData(() => this.getDataSourceName(), this.saveReportFile.ReportTitle, this.dataList);
  };
  public CreateReport = (e) => {
    if (!e.report.reportFile) e.report.reportFile = this.saveReportFile.FileName;
  };
  public SaveReport = (e) => {
    var jsonStr = e.report ? e.report.saveToJsonString() : e.saveToJsonString();
    this.saveReportFile.FileInfo = jsonStr;
    this.saveReportFile.FileName = this.fnGetRepoPath(this.saveReportFile.FileName);
    this.hcs.saveReportFile(this.apiName.split("/")[0], this.saveReportFile).subscribe(
      (x) => {
        this.tabsservice.tabItemonRefreshData.next(this.apiName);
        this.sts.showToast("success", "", this.translate("ClientApp.StimulSoft.ReportSaveSuccess"));
      },
      (error) =>
        this.sts.showDialog(
          `${this.translate("ClientApp.StimulSoft.ReportSaveFaild")}: ${Utilities.getHttpResponseMessage(error)}`,
          this.translate("ClientApp.StimulSoft.ReportSaveFaild")
        )
    );
  };
  fnGetRepoPath(n: string): string {
    n = n.replace(".mrt", "").replace(".xml", "");
    return n + ".xml";
  }
}
